import { FaFacebookF, FaLinkedin, FaPhone } from "react-icons/fa6"
import { IoMail } from "react-icons/io5"
import { PropTypes } from 'prop-types';
import YouTubeEmbed from "../utils/youtubeEmbed";

const InfiniteImpact = ({ ourAlumni }) => {



    const mainTitle = ourAlumni?.mainTitle
    const mainDescription = ourAlumni?.mainDescription
    const getInvolved = ourAlumni?.getInvolved?.items?.map((item, index) => {
        item = item?.content?.properties
        return {
            number: index < 10 ? `0${index + 1}` : index + 1,
            title: item?.label,
            description: item?.value
        }
    }

    )



    const youtubeVideoLinkURL = ourAlumni?.youtubeVideoLinkURL
    const followUs = ourAlumni?.followUs
    const updateYourContactDetailsDescription = ourAlumni?.updateYourContactDetailsDescription
    const emailAddress = ourAlumni?.emailAddress
    const phoneNumber = ourAlumni?.phoneNumber
    return (
        <div className="flex flex-col items-center bg-[#F2F3F4] lg:p-8 2xl:p-16">
            <div className="flex items-center md:p-6 2xl:mb-16">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
                    <div className="flex flex-col gap-8 p-6">
                        <h1 className="w-auto  text-slate-900 text-3xl md:text-5xl font-bold ">{mainTitle}</h1>
                        <p className="w-auto  text-justify text-sky-950 text-opacity-70 text-base font-normal leading-normal">{mainDescription}</p>
                        <h2 className="w-auto  text-2xl md:text-4xl font-bold capitalize">Get Involved :</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                            {
                                getInvolved?.map((item, index) => (
                                    <div key={index} className="flex flex-col gap-4">
                                        <h1 className="w-auto  text-slate-900 text-xl font-bold flex flex-col gap-3 capitalize"><span>{item.number}.</span> {item.title}</h1>
                                        <p className="w-auto  text-justify text-sky-950 text-opacity-70 text-base font-normal leading-normal">{item.description}</p>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <div className="flex flex-col gap-4 p-6">
                        <YouTubeEmbed videoUrl={youtubeVideoLinkURL} />
                        <div className="flex flex-col gap-4">
                            <h2 className="w-auto  text-slate-900 text-2xl font-bold capitalize">Follow Us</h2>
                            <div className="py-2 flex gap-5 items-center">
                                <a href={followUs && followUs[0]} target="_blank" rel="noreferrer" className='flex items-center justify-center w-7 h-7 2xl:w-10 2xl:h-10 rounded-full bg-[#0039CB1A] hover:text-[#003acbb7] bg-opacity-65  text-white transition-all'>
                                    <FaFacebookF />
                                </a>
                                <a href={followUs && followUs[1]} target="_blank" rel="noreferrer" className='flex items-center justify-center w-7 h-7 2xl:w-10 2xl:h-10 rounded-full bg-[#0039CB1A] hover:text-[#003acbb7] bg-opacity-65 text-white transition-all'>
                                    <FaLinkedin />
                                </a>
                            </div>
                        </div>
                        <div className="flex flex-col gap-4 ">
                            <h2 className="w-auto  text-slate-900 text-2xl font-bold capitalize">Update Your Contact Details</h2>
                            <p className="w-auto  text-justify text-sky-950 text-opacity-70 text-base font-normal leading-normal">{updateYourContactDetailsDescription}</p>
                            <div className="flex flex-col gap-5 my-3">

                                <span className="text-base font-normal leading-normal flex items-center  whitespace-nowrap ">
                                    <div className="w-8">
                                        <FaPhone size={20} />
                                    </div>
                                    {phoneNumber}</span>
                                <span className="text-base font-normal leading-normal flex items-center  whitespace-nowrap ">
                                    <div className="w-8">
                                        <IoMail size={20} />
                                    </div>
                                    {emailAddress}</span>
                            </div>
                        </div>
                    </div>

                </div>

            </div>


        </div>
    )
}
InfiniteImpact.propTypes = {
    ourAlumni: PropTypes.any
}
export default InfiniteImpact